var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex","flex-direction":"column","align-items":"center"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":_vm.color,"size":80,"width":7}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }